import { en } from "./catalogs/en";
import { zhCN } from "./catalogs/zh-CN";
import type { AppLocale, MessageCatalog, MessageKey } from "./types";

export const catalogs: Record<AppLocale, MessageCatalog> = {
  "zh-CN": zhCN,
  en,
};

export function flattenKeys(value: unknown, prefix = ""): string[] {
  if (typeof value === "string") return prefix ? [prefix] : [];
  if (!value || typeof value !== "object") return [];
  return Object.entries(value as Record<string, unknown>).flatMap(([key, child]) =>
    flattenKeys(child, prefix ? `${prefix}.${key}` : key),
  );
}

export function lookup(catalog: MessageCatalog, key: MessageKey): string {
  const parts = key.split(".");
  let current: unknown = catalog;
  for (const part of parts) {
    if (!current || typeof current !== "object" || !(part in current)) return key;
    current = (current as Record<string, unknown>)[part];
  }
  return typeof current === "string" ? current : key;
}

export function translate(locale: AppLocale, key: MessageKey, vars?: Record<string, string | number>): string {
  const template = lookup(catalogs[locale] ?? catalogs["zh-CN"], key);
  if (!vars) return template;
  return template.replace(/\{(\w+)\}/g, (match, name: string) => (name in vars ? String(vars[name]) : match));
}
